import { commonItems } from '@/utils-v2/di/providers/menu/common-items';

export default {
  items: commonItems,
};
